import { useQuery } from "react-query";
import { KandidatDetailResponse } from "../../../../models/Kandidat";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const fetchKandidatDetailKey = "kandidat-detail-key";

export async function fetchKandidatDetail(
  KANDIDAT_ID: string
): Promise<KandidatDetailResponse> {
  const res = await ApiClient.get(
    `/KandidatDetail?KANDIDAT_ID=${KANDIDAT_ID}`
  );
  return res.data;
}

export default function useFetchKandidatDetail(KANDIDAT_ID: string) {
  return useQuery(
    [fetchKandidatDetailKey, KANDIDAT_ID],
    queryWrapper(fetchKandidatDetail)
  );
}
